<template>
  <el-dialog :title="dialogTitle" :visible.sync="editInstallPlanFormVisible" class="dialog_block" width="600" height="500" :close-on-click-modal="false">
    <el-form
      :model="daohuoPlanForm"
      :rules="rules"
      ref="daohuoPlanForm"
      label-width="100px"
      class="demo-dynamic"
    >
      <el-form-item label="到货时间" prop="planDate">
        <el-date-picker class="pro_workTime" v-model="daohuoPlanForm.planDate" type="datetime" value-format="yyyy-MM-dd HH:mm"
                        placeholder="选择日期" :picker-options="pickerOptions" @change="changeTableDate">
        </el-date-picker>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="物流公司" prop="logisticsCompany">
            <el-input v-model="daohuoPlanForm.logisticsCompany"  maxlength="50" class="pro_el-input" placeholder="请输入物流公司"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物流单号" prop="logisticsNo">
            <el-input v-model="daohuoPlanForm.logisticsNo"  maxlength="20" class="pro_el-input" placeholder="请输入物流单号"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="物流对接人" prop="logisticsUser">
            <el-input v-model="daohuoPlanForm.logisticsUser"  maxlength="10" class="pro_el-input" placeholder="请输入物流对接人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="daohuoPlanForm.phone"  maxlength="11" class="pro_el-input" placeholder="请输入联系电话"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="是否需要转运" prop="isTransport">
            <el-select v-model="daohuoPlanForm.isTransport" placeholder="请选择">
              <el-option
                v-for="item in isTransportOption"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="到货方式" prop="arrivalMode">
            <el-select v-model="daohuoPlanForm.arrivalMode" placeholder="请选择" @change="arrivalModeChange">
              <el-option
                v-for="item in arrivalModeOption"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>


    <div v-if="daohuoPlanForm.arrivalMode=='自提'" style="border: 1px solid rgba(245, 247, 250, 1);padding-right: 20px;">
      <div style="margin:10px 0 10px 24px;font-weight: 600;font-size: 16px">自提信息</div>
          <el-form-item label="地址">
            <el-input v-model="daohuoPlanForm.arrivalDataInfo.addr"  maxlength="50" class="pro_el-input" placeholder="请输入地址"></el-input>
          </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="件数">
            <el-input v-model="daohuoPlanForm.arrivalDataInfo.jianshu" class="pro_el-input" placeholder="请输入件数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="方数">
            <el-input v-model="daohuoPlanForm.arrivalDataInfo.fangshu" class="pro_el-input" placeholder="请输入方数"></el-input>
          </el-form-item>
        </el-col>
      </el-row>


          <el-form-item label="到货内容">
            <textarea v-model="daohuoPlanForm.arrivalDataInfo.content"  maxlength="200" prefix-icon="el-icon-tickets" style="width: 100%" class="pro_bz mb_7" placeholder="请输入到货内容"></textarea>
          </el-form-item>
    </div>
      <div v-if="daohuoPlanForm.arrivalMode=='货到现场'"  style="border: 1px solid rgba(245, 247, 250, 1);padding-right: 20px;">

        <div v-for="(item,index) in daohuoPlanForm.carIformationList" :key="index" style="border-bottom: 1px solid rgba(245, 247, 250, 1)">
          <el-row>
            <el-col v-if="daohuoPlanForm.carIformationList.length>1" :span="12" style="padding:10px 0 10px 24px;font-weight: 600;font-size: 16px">到货车次及车型{{index+1}}</el-col>
            <el-col v-else :span="24" style="padding:10px 0 10px 24px;font-weight: 600;font-size: 16px">到货车次及车型{{index+1}}</el-col>
            <el-col :span="12" v-if="daohuoPlanForm.carIformationList.length>1" style="text-align: right;padding:10px 0">
              <el-button class="delBtn width_80 fz_12" @click="delCarIformation(index)">删除</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="车辆类型">
                <el-select v-model="item.carModel" placeholder="请选择车辆">
                  <el-option
                    v-for="item in carList"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车牌号">
                <el-input v-model="item.carPlateNumber"  maxlength="10" class="pro_el-input" placeholder="请输入车牌号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="件数">
                <el-input v-model="item.number" class="pro_el-input" placeholder="请输入件数"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="方数">
                <el-input v-model="item.SquareNumber" class="pro_el-input" placeholder="请输入方数"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="司机姓名">
                <el-input v-model="item.driverName"  maxlength="10" class="pro_el-input" placeholder="请输入司机姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="司机电话">
                <el-input v-model="item.driverPhone"  maxlength="11" class="pro_el-input" placeholder="请输入司机电话"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="到货内容">
            <textarea v-model="item.content" prefix-icon="el-icon-tickets"  maxlength="200" style="width: 100%" class="pro_bz mb_7"  placeholder="请输入到货内容"></textarea>
          </el-form-item>
        </div>
        <el-row style="text-align: center;margin-bottom: 20px;">
          <el-button class="el-button borderbtn addAlt el-button--default" style="height: 32px;" @click="addCarIformation">新增到货车次及车型</el-button>
        </el-row>
      </div>
    </el-form>
    <hr>
    <div class="foot_span">
      <el-button class="borderbtn width_80 fz_12" @click="save(1)">保存</el-button>
      <el-button class="blockbtn width_80 fz_12" @click="save(2)" v-if="!source">继续添加</el-button>
      <!-- <el-button @click="close">取 消</el-button> -->
    </div>
  </el-dialog>
</template>

<script>
import { objKeySort } from "@/util/ajaxsign";
export default {
  name: "editBasePlan",
  data() {
    return {
      editInstallPlanFormVisible: false,
      dialogTitle: "添加到货计划",
      typeId:0,
      daohuoPlanForm: {
        id: "",
        planDate:"",
        logisticsNo: "",
        logisticsCompany:"",
        logisticsUser:"",
        phone:"",
        isTransport:"",
        arrivalMode:"",
        arrivalDataInfo:{},
        carIformationList:[],
        fangshuSum:0,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= new Date().getTime() - 86400000;
        }
      },
      isTransportOption:['是，需要现场地库倒货','是，需要现场地面倒货','否，不需要倒货'],
      arrivalModeOption:['自提','货到现场'],
      carList:['17.5m平板','17.5m厢货','13m高栏','13m厢货','9.6m高栏','9.6m厢货','7.6m高栏','7.6m厢货','6.8m高栏','6.8m厢货','4.2m高栏','4.2m厢货','金杯/全顺'],
      rules: {
        planDate: [{ required: true, message: "请填写到货时间", trigger: "blur" }],
        content: [{ required: true, message: "请填写到货内容", trigger: "blur" }]
      }
    };
  },

  created() {

  },
  filters: {

  },
  methods: {

    //选择开工时间
    changeTableDate(e) {
      let that = this
      console.log("勘察日期：",e);
      that.daohuoPlanForm.planDate = e
    },


    setData(data,source) {
      this.editInstallPlanFormVisible = true;
      this.cleanForm();
      this.source = source;
      if (data) {
        this.daohuoPlanForm = data;
        this.dialogTitle = "修改到货计划";
      } else {
        this.dialogTitle = "添加到货计划";
        this.cleanForm();
      }
    },
    save(type) {
       let that =this
      that.$refs.daohuoPlanForm.validate(valid => {
        if (valid) {
          let fangshuSum = 0;
          debugger
          if(that.daohuoPlanForm.arrivalMode=='自提'){
            fangshuSum = that.daohuoPlanForm.arrivalDataInfo.fangshu;
          }
          if(that.daohuoPlanForm.arrivalMode=='货到现场'){
            for(let i=0;i<that.daohuoPlanForm.carIformationList.length;i++){
              let item = that.daohuoPlanForm.carIformationList[i];
              fangshuSum = fangshuSum+parseInt(item.SquareNumber);
            }
          }
          that.daohuoPlanForm.fangshuSum = fangshuSum;
          that.$emit("setContent", 2,that.daohuoPlanForm);
          if (type == 1) {
            that.close();
          } else {
            that.cleanForm();
          }
        } else {
          return false;
        }
      });
    },


    addCarIformation() {
      this.daohuoPlanForm.carIformationList.push({
        carModel:'',
        carPlateNumber:'',
        number:'',
        SquareNumber:'',
        driverName:'',
        driverPhone:'',
        content:''
      })
    },

    delCarIformation(index){
      this.daohuoPlanForm.carIformationList.splice(index,1);
    },

    arrivalModeChange(e){
      if(e=='货到现场'){
        this.daohuoPlanForm.carIformationList=[{
          carModel:'',
          carPlateNumber:'',
          number:'',
          SquareNumber:'',
          driverName:'',
          driverPhone:'',
          content:''
        }]
      }

    },



    close() {
      this.editInstallPlanFormVisible = false;
      this.cleanForm();
    },
    cleanForm() {

        if(this.$refs.daohuoPlanForm){
          this.$refs.daohuoPlanForm.clearValidate();

          this.daohuoPlanForm = {
            id: "",
            index:-1,
            planDate:"",
            logisticsNo: "",
            logisticsCompany:"",
            logisticsUser:"",
            phone:"",
            isTransport:"",
            arrivalMode:"",
            arrivalDataInfo:{},
            carIformationList:[],
            fangshuSum:0,
          };
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .mb_7{
    margin-bottom: 7px;
  }
  .pro_el-input{
    width: 100% !important;
  }
  .width_80{
    width: 80px;
    margin-top: 0;
  }
  .el-button{
   padding: 1px 16px;
  }
  .el-upload--picture-card{
    width: 125px;
    height: 125px;
    border-radius:3px;
    border:1px solid rgba(237,239,242,1);
    img{
      width: 100%;
      height: 100%;
      object-fit: contain !important;
    }
  }
  .el-upload-list__item{
    img{
      width: 100%;
      height: 100%;
      object-fit: contain !important;
    }
  }

  .delBtn {
    color: #FF0000;
    border-radius: 4px;
    border: 1px solid #FF0000;
  }

  .foot_span{
    text-align: right;
    margin-right: 56px;
  }
  hr {
    bottom: 72px;
    border-color: rgba(245, 247, 250, 0.2);
    margin-bottom: 15px;
  }
  .el-dialog__body{
    padding: 0 !important;
  }
  .el-upload-list__item:first-child{
    margin-top: 0 !important;
  }
</style>
